import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"

export default script